import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {Editable} from './Editable';
import * as Types from '../../types';

interface Props {
  onEdit?: (type: Types.ProfileFormType) => void;
  leadershipExperience: boolean;
}
export const LeadershipExperience = ({onEdit, leadershipExperience}: Props) => {
  const {t} = useTranslation();

  const onEditHandler = () => {
    onEdit && onEdit('leadership-experience');
  };

  const leadershipText = leadershipExperience ? t('shared.yes') : t('shared.no');

  return (
    <Box>
      <Editable onEdit={onEditHandler}>
        <Typography variant='h2' paddingBottom='16px'>
          {t('applicantProfile.leadershipExperience.title')}
        </Typography>
        <Typography variant='body1'>{leadershipText}</Typography>
      </Editable>
    </Box>
  );
};
